import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { api } from '../lib/api'
import { TenantSetup } from './TenantSetup'

/**
 * Wraps a tenant-dependent tab. A trial now starts before the database exists (see
 * `POST /api/onboarding/complete`), so every screen whose data lives in the tenant database
 * needs to degrade to the same "connect your database" prompt Inbox already shows, rather than
 * whatever its own query's 409 error state happens to render.
 *
 * Reuses the `['tenant']` query key already warm from `App.tsx`'s own fetch — React Query
 * dedupes by key, so this costs no extra request on a ready workspace.
 */
export function TenantGuard({ children }: { children: ReactNode }) {
  const tenant = useQuery({ queryKey: ['tenant'], queryFn: api.tenant })
  if (tenant.isPending) return <div className="skeleton" style={{ height: '220px' }} />
  if (tenant.data?.tenant?.status === 'ready') return <>{children}</>
  return <TenantSetup />
}
